import { DialogTitle } from "@radix-ui/react-dialog";
import { Dialog, DialogContent } from "../../../../components/ui/dialog";
import type { ReactNode } from "react";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  header?: ReactNode;
  footer?: ReactNode;
  children?: ReactNode;
  modalContentClassName?: string;
}

export const AddModal = ({
  isOpen,
  onClose,
  header,
  footer,
  children,
  modalContentClassName,
}: Props) => {
  return (
    <>
      <Dialog open={isOpen} onOpenChange={onClose}>
        <DialogTitle></DialogTitle>
        <DialogContent
          aria-describedby=""
          showCloseButton={false}
          className={`flex flex-col max-h-[90vh] w-full max-w-[620px] p-0 ${modalContentClassName || ""}`}
        >
          {header && <div className="flex-shrink-0">{header}</div>}
          <div className="flex-1 min-h-0 overflow-y-auto">{children}</div>
          {footer && <div className="flex-shrink-0 mt-0">{footer}</div>}
        </DialogContent>
      </Dialog>
    </>
  );
};
